import { render, staticRenderFns } from "./ModulePlacements.vue?vue&type=template&id=633e6817&scoped=true&"
import script from "./ModulePlacements.vue?vue&type=script&lang=js&"
export * from "./ModulePlacements.vue?vue&type=script&lang=js&"
import style0 from "./ModulePlacements.vue?vue&type=style&index=0&id=633e6817&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633e6817",
  null
  
)

export default component.exports